import React from 'react';
import usePastTime from 'hooks/usePastTime';
import { DataRoomInvitationsTable } from './data';
import { CellProps, COMMON_BODY_CONTENT_GENERATE } from '../../../TableCells';

type DRCellProps = CellProps & {
  createdAt?: Date;
};

const InvitedCellComponent: React.FC<DRCellProps> = ({ createdAt }) => {
  const pastTime = usePastTime()(createdAt);

  if (!pastTime) return null;

  return <div className="pdt-published-cell">{pastTime}</div>;
};

export const BODY_CONTENT_GENERATE: Record<
  keyof DataRoomInvitationsTable,
  (cellProps: DRCellProps) => React.ReactNode
> = {
  ...COMMON_BODY_CONTENT_GENERATE,
  createdAt: (cellProps: DRCellProps) => (
    <InvitedCellComponent {...cellProps} />
  ),
};
